/* 
  NOTE: We can access the content of the popup programatically 
  after it has opened or closed via the custom events that are
  emitted ('popup:open', 'popup:close'). To get the content of
  the data after a popup is opened you would do the following:
  $(document).on('popup:open', function(e) {
	var $popupContent = $(e.target);
	// do stuff with $popupContent
  });
  You can do this from any JS file or block. It doesnt have 
  to be contained in this file.
*/
/*
  NOTE: There are several ways to trigger a popup.
  1) Create a div on the page with the ID 'popup_[something]'. 
	 It will be hidden by default. Trigger it by clicking on 
	 an element with the following attribute:
	 'data-popup-trigger="popup_[something]"'
  2) Create the same div as step 1, but trigger the popup 
	 dymanically by calling the function triggerPopup() and 
	 passing an options object like this:
	 triggerPopup({hash: '#popup_[something]'});
  3) You can also use the triggerPopup() function to dynamically
	 create a popup by passing HTML like this:
	 triggerPopup({data: '<p>I'm a popup</p>'});
  4) A popup that exists on the page (see #1) can be called as
	 a call back to another popup (i.e. opened after the 1st popup
	 closes. Open a popup via methods 2 or 3 and pass the ID of an 
	 existing popup on the page as a second parameter to the 
	 triggerPopup() function like this:
	 triggerPopup({callbackPopup: '#popup_[somethingElse]'});
  5) You can also create a callback popup by passing HTML to the
	 triggerPopup() function like this:
	 triggerPopup({callbackPopupData: '<p>I'm a callback popup</p>'});
*/
/*
  NOTE: Triggers that exist on the page (see #1 above) have several
  optional parameters:
  1) data-width="integer":
	 Set the display width of this specific popup (will never be
	 more than 100% of the viewport). It applies only to instances
	 of the popup opened by this triger.
  2) data-target="url"
	 For use in interstitial popups. Set a url to open in a new
	 tab after popup displays. (Popup must contain an <a> tag with
	 the class externalLink). This would be useful to have multiple
	 triggers that point to different external URL's that all make
	 use of the same popup.
  3) data-callback-popup="ID"
	 Similar to #4 above, you can pass the ID of another popup to 
	 be opened when the current popup is closed.
  4) data-callback-popup-data="HTML"
	 Similar to #5 above, you can pass some HTML to be opened as a
	 popup when the current popup is closed.
*/
/*
  NOTE: Popups that exist on the page (see #1 above) have an optional
  parameter:
  1) data-width="integer":
	 Set the display width of this specific popup (will never be
	 more than 100% of the viewport). It applies to all instances
	 of this popup.
*/
/************************************
 ****** Trigger Popup By Click  ******
 ************************************/
const exclusionList = document.getElementById('excluded-popup-links');
const excludedLinks = exclusionList ? JSON.parse(exclusionList.textContent) : [];
excludedLinks.forEach((link, index) => {
  console.log(`Link ${index + 1}:`, link);
});
blue.ready('popups', 'a[href]', link => {
	if (!link.closest("[id^='popup_']") && !link.closest('.heroIE-login')) {
		let siteHost = window.location.host
    let urlHost = link.hostname;
 
    if (urlHost && !urlHost.includes('localhost') && siteHost != urlHost && !link.classList.contains('no-external-link') && !excludedLinks.includes(urlHost)) {
			link.setAttribute('data-popup-trigger', '#popup_external');
			link.setAttribute('data-target', link.getAttribute('href'));
			let classList = link.getAttribute("class");
			let classCode = '';
			if (classList) {
				classCode = classList.split(' ').find(x => x.includes('extpop-'));
			}
			var externalPopupText = getExternalPopupText(classCode);
			link.setAttribute('data-external-title', externalPopupText.title);
			link.setAttribute('data-external-body', externalPopupText.body);
			link.setAttribute('data-external-button', externalPopupText.button);
		}
	}
});
document.addEventListener('click', function (e) {
  var target = e.target;
  var popupTrigger = target.closest('[data-popup-trigger]');
  if (popupTrigger) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
    var hash = popupTrigger.getAttribute('data-popup-trigger');
    var keyboard = false;
    if (e.screenX === 0 && e.screenY === 0) {
      keyboard = true;
    }
    if (!target.classList.contains("contentSlide-cta")) {
      triggerPopup({
        hash: hash,
        trigger: popupTrigger,
        keyboard: keyboard
      });
    }
  }
});
function getExternalPopupText(code) {
	var popupText = {
		title: '',
		body: '',
		button: ''
	};
	if (typeof externalPopupCodes !== 'undefined' && externalPopupCodes[code] && externalPopupCodes[code].title && externalPopupCodes[code].body) {
		if (externalPopupCodes[code].title) {
			popupText.title = externalPopupCodes[code].title;
		}
		if (externalPopupCodes[code].body) {
			popupText.body = externalPopupCodes[code].body;
		}
		if (externalPopupCodes[code].button && externalPopupCodes[code].button !== "") {
			popupText.button = externalPopupCodes[code].button;
		}
	}
	return popupText;
}
/************************************
 ** Trigger Popup Programmatically  **
 
 This was originally written in jQuery,
 but ChatGPT converted it to vanilla JS
 ************************************/
 function triggerPopup(params) {
  /* ----------------------------------
  ----- Process Options ---------------
  ---------------------------------- */
  var defaults = {
    hash: '',
    data: '',
    callbackPopup: '',
    callbackPopupData: '',
    trigger: '',
    keyboard: false
  };
  var options = Object.assign({}, defaults, params);
  /* ----------------------------------
  ----- Close Existing Popups ---------
  ---------------------------------- */
  var existingPopups = document.querySelectorAll('.popup');
  if (existingPopups.length) {
    existingPopups.forEach(function (popup) {
      var closeButton = popup.querySelector('.popup-close');
      if (closeButton) {
        closeButton.click();
      }
    });
  }
  /* ----------------------------------
  ----- Variables ---------------------
  ---------------------------------- */
  var triggerElement = options.trigger;
  var keyboard = options.keyboard;
  var dataElement;
  var onPage = false;
  if (options.data === '') {
    dataElement = document.querySelector(options.hash);
    onPage = true;
  } else {
    dataElement = document.querySelector(options.data);
  }
  var placeholder = document.createElement('placeholder');
  placeholder.style.display = 'none';
  var popupElement = document.createElement('div');
  popupElement.classList.add('popup');
  popupElement.style.display = 'none';
  var overlayElement = document.createElement('div');
  overlayElement.classList.add('popup-overlay');
  var contentElement = document.createElement('div');
  contentElement.classList.add('popup-content');
  var closeElement = document.createElement('div');
  closeElement.classList.add('popup-close');
  closeElement.tabIndex = 0;
  /* ----------------------------------
  ----- Local Functions ---------------
  ---------------------------------- */
  function openPopup() {
    var openEvent = new CustomEvent('popup:open', {
      detail: {
        target: contentElement
      }
    });
    popupElement.addEventListener('popup:open', function () {
      if (onPage) {
        dataElement.parentNode.insertBefore(placeholder, dataElement);
      }
      contentElement.appendChild(closeElement);
      contentElement.appendChild(dataElement);
      overlayElement.appendChild(contentElement);
      popupElement.appendChild(overlayElement);
      document.body.appendChild(popupElement);
      document.body.classList.add('is-blurred');
      document.documentElement.classList.add('no-scroll');
      document.documentElement.classList.add('popup-open');
      popupElement.style.display = 'block';
      if (keyboard) {
        contentElement.setAttribute('tabindex', 0);
        contentElement.focus();
      }
    });
    document.querySelector('.pageWrap').after(popupElement);
    popupElement.dispatchEvent(openEvent);
  }
  function closePopup() {
    var closeEvent = new CustomEvent('popup:close', {
      detail: {
        target: contentElement
      }
    });
    popupElement.addEventListener('popup:close', function () {
      popupElement.style.display = 'none';
      if (onPage) {
        placeholder.after(dataElement);
        placeholder.remove();
      }
      popupElement.remove();
      var callbackPopup = options.callbackPopup;
      var callbackPopupData = options.callbackPopupData;
      if (callbackPopup) {
        triggerPopup({
          hash: callbackPopup
        });
      } else if (callbackPopupData) {
        triggerPopup({
          data: callbackPopupData
        });
      } else if (triggerElement && triggerElement.dataset.callbackPopup) {
        triggerPopup({
          hash: triggerElement.dataset.callbackPopup
        });
      } else if (triggerElement && triggerElement.dataset.callbackPopupData) {
        triggerPopup({
          data: triggerElement.dataset.callbackPopupData
        });
      }
      document.querySelector('.pageWrap').classList.remove('is-blurred');
      document.documentElement.classList.remove('no-scroll');
      document.documentElement.classList.remove('popup-open');
      var $trigger = options.trigger;
      if ($trigger) {
        $trigger.setAttribute('tabindex', 0);
        $trigger.focus();
      }
    });
    popupElement.dispatchEvent(closeEvent);
  }
  /* ----------------------------------
  ----- Set Specific Width ------------
  ---------------------------------- */
  if (dataElement.hasAttribute('data-width')) {
    contentElement.style.width = dataElement.getAttribute('data-width');
  }
  if (triggerElement && triggerElement.hasAttribute('data-width')) {
    contentElement.style.width = triggerElement.getAttribute('data-width');
  }
  /* ----------------------------------
  ----- Set External Link -------------
  ---------------------------------- */
  if (triggerElement && triggerElement.hasAttribute('data-target')) {
    var exitLinkElement = dataElement.querySelector('.js-externalLink');
    var target = triggerElement.getAttribute('target') || '_blank';
    exitLinkElement.setAttribute('href', triggerElement.getAttribute('data-target'));
    exitLinkElement.setAttribute('target', target);
    exitLinkElement.addEventListener('click', function () {
      closePopup();
    });
    if (triggerElement.hasAttribute('data-external-button') && triggerElement.getAttribute('data-external-button').length > 0) {
      exitLinkElement.innerHTML = triggerElement.getAttribute('data-external-button');
    }
  }
  /* ----------------------------------
  ----- Set External Link Title -------------
  ---------------------------------- */
  if (triggerElement && triggerElement.hasAttribute('data-external-title') && triggerElement.getAttribute('data-external-title').length > 0) {
    var titleElement = dataElement.querySelector('.js-externalTitle');
    titleElement.innerHTML = triggerElement.getAttribute('data-external-title');
  }
  /* ----------------------------------
  ----- Set External Link Body -------------
  ---------------------------------- */
  if (triggerElement && triggerElement.hasAttribute('data-external-body') && triggerElement.getAttribute('data-external-body').length > 0) {
    var bodyElement = dataElement.querySelector('.js-externalBody');
    bodyElement.innerHTML = triggerElement.getAttribute('data-external-body');
  }
  /* ----------------------------------
  ----- Popup Interactions ------------
  ---------------------------------- */
  var closePopupElements = dataElement.querySelectorAll('.js-closePopup');
  closePopupElements.forEach(function (closePopupElement) {
    closePopupElement.addEventListener('click', function (e) {
      e.preventDefault();
      closePopup();
      if (e.screenX == 0 && e.screenY == 0 && triggerElement) {
        triggerElement.setAttribute('tabindex', 0);
        triggerElement.focus();
      }
    });
  });
  closeElement.addEventListener('click', function () {
    closePopup();
  });
  closeElement.addEventListener('keypress', function (e) {
    if (e.which == 13) {
      closePopup();
      if (triggerElement) {
        triggerElement.setAttribute('tabindex', 0);
        triggerElement.focus();
      }
    }
  });
  overlayElement.addEventListener('click', function (e) {
    var target = e.target;
    if (!target.closest('.popup-content')) {
      closePopup();
    }
  });
  openPopup();
}